import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation, useNavigate, useParams } from "react-router-dom";
import "../../../ext.css";
import "../../../animate.css";
import Home from "../ext/Home";
import Profile from "../ext/Profile";
import { useQuery } from "react-query";
import { getUser } from "../../../apis/ext";
import SharedDataContext from "../../../SharedDataContext";
import Login from "../../ext/Login";
import HowToBegin from "../../ext/HowToBegin";
import posthog from "posthog-js";
// import ToastContainer from "../../ext/ToastContainer";
import BulkProfile from "../ext/BulkProfile";
import { useIntegrations } from "../../../apiHooks/useIntegrations";
import { useStoreIntegrations } from "../../../stores/useStoreIntegrations";
import { useSetPreferences } from "../../../apiHooks/useSetPreferences";
import { useGetCRMSavedConfig } from "../../../apiHooks/useGetCRMSavedConfig";
import { useSetWorkspacePreferences } from "../../../apiHooks/useSetWorkspacePreferences";
import BulkAccounts from "../ext/BulkAccounts";

function ContactViewerApp() {
  const [params, setParams] = useState({});
  const [version, setVersion] = useState("");
  const [companyLinkedinUrl, setCompanyLinkedinUrl] = useState("");

  const getAllUrlParams = (newURL) => {
    const [beforeQuestionMark, queryPart = ""] = newURL.split("?");
    if (!queryPart) {
      return {};
    }
    const [rawQuery] = queryPart.split("#");
    const pairs = rawQuery.split("&");
    const paramsObject = {};
    for (const pair of pairs) {
      const [key, value = ""] = pair.split("=");
      paramsObject[key] = value;
    }
    return paramsObject;
  };
  useEffect(() => {
    if (typeof window !== "undefined") {
      console.log(getAllUrlParams(window.location.href));
      const paramsObj = getAllUrlParams(window.location.href);
      const { ref, version, source } = paramsObj || {};
      let obj = {};
      if (ref) {
        const decodedString = decodeURIComponent(ref);
        obj = JSON.parse(atob(decodedString));
      }
      if (version) {
        setVersion(version);
      }
      if (source) {
        obj.source = source;
      }

      if (obj && obj.company_url) {
        setCompanyLinkedinUrl(obj.company_url);
      }
      if (obj && obj.isCompanyPage && obj.url) {
        setCompanyLinkedinUrl(obj.url);
      }

      setParams(obj);
    }
  }, [window]);

  const [extensionLoaded, setExtensionLoaded] = useState(false);
  useEffect(() => {
    setExtensionLoaded(true);
  }, []);
  const excludedPaths = ["/login"];
  const location = useLocation();
  const navigate = useNavigate();

  const { data: userData, isSuccess } = useQuery("get_user", getUser, {
    enabled: extensionLoaded && !excludedPaths.includes(location.pathname),
    refetchOnWindowFocus: false,
    retry: false,
  });

  const { refetch: refetchIntegrations } = useIntegrations(userData?.data?.activeWorkspace?.id);
  const { installedCRMIntegrations, activeCRMIntegration, setActiveCRMIntegrationById } =
    useStoreIntegrations();

  const setPreferencesFn = useSetWorkspacePreferences(
    (data) => {
      console.log("✅ Preferences saved:", data);
      // maybe show toast
    },
    (error) => {
      console.error("❌ Failed to save preferences:", error);
      // maybe show error toast
    }
  );

  const getSavedCRMConfigFn = useGetCRMSavedConfig(
    (data) => {
      console.log("CRM config saved:", data);
    },
    (error) => {
      console.error("CRM config failed:", error);
    }
  );

  useEffect(() => {
    if (isSuccess && userData?.data) {
      const user = userData.data;
      if (version) {
        posthog.identify(user.id, {
          email: user.email,
          name: user.name,
          chrome_extension_version: version,
        });
      } else {
        posthog.identify(user.id, {
          email: user.email,
          name: user.name,
        });
      }
      posthog.group("workspace", user?.activeWorkspace?.slug, {
        name: user?.activeWorkspace?.name,
        slug: user?.activeWorkspace?.slug,
        id: user?.activeWorkspace?.id,
      });
    }
  }, [isSuccess, userData, version]);

  useEffect(() => {
    if (
      userData?.data?.activeWorkspace?.id &&
      installedCRMIntegrations &&
      installedCRMIntegrations.length > 0
    ) {
      const activeCRMs = installedCRMIntegrations.filter((el) => el.is_enabled);
      if (activeCRMs && activeCRMs.length > 0) {
        console.log("activeCRMs", activeCRMs);
        let activeCRMobj = activeCRMs.find(
          (el) =>
            el.is_enabled &&
            userData?.data?.activeWorkspace.preferences &&
            `${el.id}` ===
              `${userData?.data?.activeWorkspace.preferences?.active_crm_workspace_integration_config_id}`
        );

        console.log("activeCRMobj in viewer", activeCRMobj);
        if (activeCRMobj) {
          console.log("activeCRMobj in viewer in");
          setActiveCRMIntegrationById(activeCRMobj?.id);
          getSavedCRMConfigFn.mutate({
            crmKey: activeCRMobj?.integration?.key,
            crmConfigId: activeCRMobj?.id,
            options: {
              headers: { "X-Workspace-Id": userData?.data?.activeWorkspace?.id },
            },
          });
        }

        if (!activeCRMobj) {
          setPreferencesFn.mutate({
            data: {
              preferences: {
                active_crm_workspace_integration_config_id: activeCRMs[0]?.id,
              },
            },
            options: {
              headers: { "X-Workspace-Id": userData?.data?.activeWorkspace?.id },
            },
          });
        }
      }
    }
  }, [isSuccess, userData, installedCRMIntegrations]);

  console.log("activeCRMIntegration in viewer", activeCRMIntegration);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleUnauthenticated = () => {
        console.log("window user logout");
        navigate("/contact-viewer/login");
      };
      window.addEventListener("user_unauthenticated_ext", handleUnauthenticated);
      return () => {
        window.removeEventListener("user_unauthenticated_ext", handleUnauthenticated);
      };
    }
  }, []);

  useEffect(() => {
    if (params && params?.bulkProfilePage) {
      navigate("/contact-viewer/bulk-profiles");
    } else if (params && params?.bulkAccountPage) {
      navigate("/contact-viewer/bulk-accounts");
    } else if (params && params?.infoPage) {
      navigate("/contact-viewer/how-to-begin");
    }
  }, [params && params?.infoPage, params?.bulkProfilePage, isSuccess]);

  return (
    <SharedDataContext.Provider
      value={{
        params,
        userData: userData?.data,
        companyLinkedinUrl,
      }}
    >
      <div className="wrapper">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/login" element={<Login />} />
          <Route path="/how-to-begin" element={<HowToBegin />} />
          <Route path="/bulk-profiles" element={<BulkProfile />} />
          <Route path="/bulk-accounts" element={<BulkAccounts />} />
        </Routes>

        {/* <ToastContainer /> */}
      </div>
    </SharedDataContext.Provider>
  );
}

export default ContactViewerApp;
